import { toggleEditableBlocks } from '../updateDynamicText/toggleEditableBlocks'
import { t } from 'i18next'

export const registerTextCasingPlugin = ({ editor }) => {
  const { unlockNonEditableBlocks, lockNonEditableBlocks } =
    toggleEditableBlocks(editor)
  const transformStyles = ['uppercase', 'capitalize', 'lowercase']

  // Helper function to get the current text-transform style of the selection
  const getTextTransform = () =>
    editor.dom.getStyle(editor.selection.getNode(), 'text-transform') || ''

  // Helper function to recursively remove the text-transform from all child nodes
  const removeTextTransformRecursive = (node) => {
    unlockNonEditableBlocks()
    if (node.nodeType === 1) {
      editor.dom.setStyle(node, 'text-transform', null)
      Array.from(node.children).forEach(removeTextTransformRecursive)
    }
    lockNonEditableBlocks()
  }

  // Apply or remove the text-transform style. The undo transaction records
  // the change as an undo level, which marks the editor dirty: a box writes
  // its HTML back on blur only when it is dirty (shouldCommitBlurContent).
  const applyTextTransform = (value) => {
    editor.undoManager.transact(() => {
      unlockNonEditableBlocks()
      if (value === 'remove') {
        removeTextTransformRecursive(editor.selection.getNode())
      } else {
        editor.formatter.register('customTextTransform', {
          inline: 'span',
          styles: { 'text-transform': value },
        })
        editor.formatter.apply('customTextTransform')
      }
      lockNonEditableBlocks()
    })
  }

  editor.ui.registry.addMenuButton('casing', {
    text: t('editor.tinyMCE.textCase.text'),
    fetch: (callback) => {
      const currentTransform = getTextTransform()
      const items = transformStyles.map((transform) => ({
        type: 'menuitem',
        text: t(`editor.tinyMCE.textCase.styles.${transform}`),
        onAction: () => applyTextTransform(transform),
        active: currentTransform === transform,
      }))

      items.push({
        type: 'menuitem',
        text: t('editor.tinyMCE.textCase.removeText'),
        onAction: () => applyTextTransform('remove'),
        active: !currentTransform,
      })

      callback(items)
    },
  })
}

export default registerTextCasingPlugin
